import React, {useEffect} from 'react';
import {change, Field} from 'redux-form';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from "react-redux";

const RatingScale = ({
    itemCols,
    name,
    min = 0,
    max = 10,
    minLabel = '',
    maxLabel = '',
    disabled = false,
    setError,
}) => {
    const dispatch = useDispatch();
    const error = useSelector(state => state.customValidationErrors.errors[name]);
    const currentValue = useSelector(state => {
        const values = state.form && state.form.wizard && state.form.wizard.values;
        return values && values[name] !== undefined ? values[name] : null;
    });

    useEffect(() => {
        if (typeof setError === 'function') setError(!!error);
    }, [error]);

    const values = [];
    for (let i = min; i <= max; i++) values.push(i);

    const handleSelect = (value) => {
        if (disabled) return;
        const stringValue = value.toString();
        if (currentValue === stringValue) {
            dispatch(change('wizard', name, null));
        } else {
            dispatch(change('wizard', name, stringValue));
        }
    };

    return (
        <div className={itemCols}>
            {error && <div className="input-error2">{error}</div>}
            <Field component="input" type="hidden" name={name} />

            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                fontSize: '0.85rem',
                color: '#6c757d',
                marginBottom: '6px',
            }}>
                <span>{minLabel}</span>
                <span>{maxLabel}</span>
            </div>

            <div style={{
                display: 'flex',
                width: '100%',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                overflow: 'hidden',
            }}>
                {values.map((v, idx) => {
                    const stringValue = v.toString();
                    const isSelected = currentValue === stringValue;
                    return (
                        <button
                            type="button"
                            key={v}
                            disabled={disabled}
                            onClick={() => handleSelect(v)}
                            style={{
                                flex: '1 1 0',
                                minWidth: 0,
                                padding: '12px 0',
                                background: isSelected ? '#28a745' : '#fff',
                                color: isSelected ? '#fff' : '#212529',
                                border: 'none',
                                borderLeft: idx === 0 ? 'none' : '2px solid #28a745',
                                cursor: disabled ? 'not-allowed' : 'pointer',
                                fontWeight: 600,
                                fontSize: '1rem',
                                textAlign: 'center',
                                outline: 'none',
                            }}
                        >
                            {v}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

RatingScale.propTypes = {
    itemCols: PropTypes.string,
    name: PropTypes.string.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    minLabel: PropTypes.string,
    maxLabel: PropTypes.string,
    disabled: PropTypes.bool,
};

export default RatingScale;
